import React, { useState } from "react";
import {
  HiMenu,
  HiX,
  HiUser,
  HiSearch,
  HiChatAlt2,
  HiQuestionMarkCircle,
} from "react-icons/hi";
import { FiShoppingCart } from "react-icons/fi";

const Navbar = ({ isLoggedIn, openCart }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [showChatPopup, setShowChatPopup] = useState(false);

  const categories = [
    {
      name: "Smoking Essentials",
      sub: ["Grinders", "Lighters", "Rolling Papers", "Ashtrays"],
    },
    {
      name: "Vapes",
      sub: ["Disposable Vapes", "Pod Systems", "E-Liquids"],
    },
    {
      name: "Accessories",
      sub: ["Stash Boxes", "Cleaning Tools", "Storage Jars"],
    },
  ];

  return (
    <>
      {/* TOP NAVBAR */}
      <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50 flex items-center justify-between px-4 py-3">

        {/* MENU ICON */}
        <button onClick={() => setMenuOpen(true)}>
          <HiMenu className="text-3xl text-gray-800" />
        </button>

        {/* BRAND NAME */}
        <h1 className="text-xl md:text-2xl font-bold text-purple-600 select-none">
          Shopatrave
        </h1>

        {/* RIGHT ICONS */}
        <div className="flex items-center gap-4 text-2xl text-gray-700">

          {/* Help */}
          <HiQuestionMarkCircle title="Help" className="cursor-pointer" />

          {/* CART */}
          {isLoggedIn && (
            <FiShoppingCart
              title="Cart"
              onClick={openCart}
              className="cursor-pointer hover:text-purple-600"
            />
          )}

          {/* Login */}
          <HiUser title="Login" className="cursor-pointer" />
        </div>
      </div>

      {/* SEARCH BAR (Desktop) */}
      <div className="hidden md:flex fixed top-16 left-0 w-full bg-white py-3 px-6 shadow z-40">
        <div className="mx-auto max-w-2xl flex items-center bg-gray-100 px-4 py-2 rounded-full w-full">
          <HiSearch className="text-xl mr-2 text-gray-500" />
          <input
            type="text"
            placeholder="Search products..."
            className="bg-transparent outline-none w-full"
          />
        </div>
      </div>

      {/* MOBILE SEARCH */}
      <div className="md:hidden fixed top-14 left-0 w-full bg-white p-2 shadow z-40">
        <div className="flex items-center bg-gray-100 px-3 py-2 rounded-full">
          <HiSearch className="text-xl mr-2 text-gray-500" />
          <input
            type="text"
            placeholder="Search products…"
            className="bg-transparent outline-none w-full"
          />
        </div>
      </div>

      {/* SIDEBAR MENU */}
      <div
        className={`fixed top-0 left-0 h-full w-72 bg-white shadow-xl z-50 transition-transform duration-300 
        ${menuOpen ? "translate-x-0" : "-translate-x-full"}`}
      >
        <div className="flex justify-between items-center p-4 border-b">
          <h2 className="text-lg font-semibold">Menu</h2>
          <HiX className="text-3xl cursor-pointer" onClick={() => setMenuOpen(false)} />
        </div>

        <div className="p-4">
          {categories.map((cat, index) => (
            <div key={index} className="mb-4">
              <button
                className="w-full text-left font-semibold text-gray-800"
                onClick={() =>
                  setActiveCategory(activeCategory === index ? null : index)
                }
              >
                {cat.name}
              </button>

              {activeCategory === index && (
                <div className="mt-2 ml-4 text-gray-600">
                  {cat.sub.map((s, i) => (
                    <p key={i} className="py-1 cursor-pointer hover:text-black">
                      {s}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* BACKDROP */}
      {menuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 z-40"
          onClick={() => setMenuOpen(false)}
        />
      )}

      {/* FLOATING CHAT AI BUTTON - ALWAYS VISIBLE */}
      <div className="fixed bottom-24 right-5 z-[9999]">
        {/* Popup text */}
        {showChatPopup && (
          <div className="mb-2 mr-0 bg-white shadow-lg text-gray-900 px-4 py-2 rounded-lg text-sm font-semibold animate-fade-in"
            style={{
              position: "absolute",
              bottom: "110%",
              right: "0",
              whiteSpace: "nowrap",
              zIndex: 10000,
              boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
            }}
          >
            Hi! Need any help?
          </div>
        )}
        <button
          className="bg-purple-600 text-white p-4 rounded-full shadow-2xl hover:bg-purple-700 transition duration-300 relative"
          onMouseEnter={() => setShowChatPopup(true)}
          onMouseLeave={() => setShowChatPopup(false)}
        >
          <HiChatAlt2 className="text-3xl" />
        </button>
      </div>
    </>
  );
};

export default Navbar;
